import { api } from "./api";

export const listarEventos = () => api.get("/evento/listar");
export const obterEvento = (id) => api.get(`/evento/${id}`);
export const salvarEvento = (dto) => api.post("/evento/salvar", dto);
export const excluirEvento = (id) => api.post(`/evento/excluir/${id}`);
export const listarInscritosEvento = (id) => api.get(`/evento/${id}/inscritos`);

const query = (params = {}) =>
  new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
  ).toString();

// Lista geral de inscritos (todos os eventos), com filtros.
export const listarInscritos = (params = {}) => {
  const qs = query(params);
  return api.get(`/evento/inscritos${qs ? `?${qs}` : ""}`);
};

const baixarArquivo = async (rota, params, extensao) => {
  const qs = query(params);
  const { data } = await api.get(`${rota}${qs ? `?${qs}` : ""}`, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = `inscritos_${new Date().toISOString().slice(0, 10)}.${extensao}`;
  document.body.appendChild(a); a.click(); a.remove();
  window.URL.revokeObjectURL(url);
};

// Relatórios (respeitam os filtros da tela).
export const baixarInscritosExcel = (params = {}) => baixarArquivo("/evento/inscritos/excel", params, "xlsx");
export const baixarInscritosPdf = (params = {}) => baixarArquivo("/evento/inscritos/pdf", params, "pdf");
export const bannerUrl = (id) => `/api/evento/banner-img/${id}`;

export const uploadBanner = (id, arquivo) => {
  const fd = new FormData();
  fd.append("arquivo", arquivo);
  return api.post(`/evento/banner/${id}`, fd, { headers: { "Content-Type": undefined } });
};
